// Decorative observatory backdrop for the nroute landing.
// Pure CSS/SVG, pointer-events-none, sits behind content. No state, module scope.
// Colors derive from platform brand tokens (--brand-*); stars keep the logo's
// North Star gold (#C9A84C, PlatformLogo) as an intentional motif echo.

// Deterministic star positions (no Math.random — stable across renders/SSR).
const STARS = [
  [8, 18, 1.2, 0.5], [15, 42, 0.8, 0.35], [23, 12, 1.5, 0.6], [31, 64, 0.9, 0.4],
  [38, 28, 1.1, 0.5], [46, 8, 0.7, 0.3], [54, 52, 1.3, 0.55], [61, 22, 0.9, 0.4],
  [68, 70, 1.0, 0.45], [74, 14, 1.4, 0.6], [82, 40, 0.8, 0.35], [88, 24, 1.1, 0.5],
  [93, 60, 0.9, 0.4], [12, 76, 1.2, 0.5], [42, 82, 0.8, 0.35], [58, 88, 1.0, 0.45],
  [78, 80, 1.3, 0.55], [5, 55, 0.9, 0.4], [97, 12, 1.1, 0.5], [50, 34, 0.7, 0.3],
];

const glow = (token, pct) =>
  `radial-gradient(circle, color-mix(in srgb, var(${token}) ${pct}%, transparent), transparent 70%)`;

export default function StarField() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {/* Aurora / north-star glows — derived from brand tokens */}
      <div
        className="absolute -top-32 left-1/2 h-[36rem] w-[36rem] -translate-x-1/2 rounded-full blur-[120px]"
        style={{ background: glow('--brand-secondary', 16) }}
      />
      <div
        className="absolute top-40 -right-24 h-[28rem] w-[28rem] rounded-full blur-[120px]"
        style={{ background: glow('--brand-accent', 14) }}
      />
      <div
        className="absolute bottom-0 -left-24 h-[26rem] w-[26rem] rounded-full blur-[120px]"
        style={{ background: glow('--brand-primary', 60) }}
      />
      {/* Star field — logo North Star gold */}
      <svg className="absolute inset-0 h-full w-full">
        {STARS.map(([x, y, r, o], i) => (
          <circle key={i} cx={`${x}%`} cy={`${y}%`} r={r} fill="#C9A84C" opacity={o} />
        ))}
      </svg>
    </div>
  );
}
